import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { useViewportDom } from 'craft/state/viewport/selectors';

const Container = styled.div<any>`
  position: absolute;
  top: ${({ top }: any) => top}px;
  left: ${({ left }: any) => left}px;

  z-index: 3;
`;

interface Props {
  top: number;
  left: number;
  children: React.ReactNode;
}

export const MenuContainer = ({ top, left, children }: Props) => {
  const ref = useRef<HTMLElement>();
  const { viewportContainerEl } = useViewportDom();
  const [position, setPosition] = useState({ top, left });

  useEffect(() => {
    const menu = ref.current;
    if (!ref || !viewportContainerEl) {
      return;
    }

    const menuBunds = menu?.getBoundingClientRect();
    const viewportBounds = viewportContainerEl?.getBoundingClientRect();
    if (
      (menuBunds?.y || 0) + (menuBunds?.height || 0) >
      (viewportBounds?.y || 0) + (viewportBounds?.height || 0)
    ) {
      setPosition({ top: top - (menuBunds?.height || 0), left });
    }
  }, []);

  return (
    <Container ref={ref} top={position.top} left={position.left}>
      {children}
    </Container>
  );
};
